import script from "./TalentPoolDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentPoolDetail.vue?vue&type=script&setup=true&lang=js"

import "./TalentPoolDetail.vue?vue&type=style&index=0&id=c955b89e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c955b89e"]])

export default __exports__